import { useContext, useEffect } from "react";
import VehiclesService from "../services/VehiclesService";
import { AppContext } from "../store/context/AppContext";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { set } from "../store/slice/vehicles";
import { Vehicles } from "../types/vehicles";

const useGetVehicles = () => {
    const context = useContext(AppContext);
    const dispatch = useAppDispatch();
    const vehicles = useAppSelector(state => state.vehicles.value);

    useEffect(() => {
        if(vehicles != null) return;

        const vehiclesService = new VehiclesService(context.globalApi);

        (async () => {
            await vehiclesService.getModels().then(res => {
                if(res.ok) {
                    dispatch(set({value : res.parsedBody as Vehicles}))
                }
            }).catch(err => console.log(err));

        })()

    }, []);
}

export default useGetVehicles;
